import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/components/news/NewsWorkspace.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/node_modules/next/dist/client/app-dir/link.js");
